export default __webpack_public_path__ + "static/media/kidjoLogo.48053bf4.svg";